/* tslint:disable */
/* eslint-disable */
/**
 * Xpanse Portal BFF Service API
 * Rest API for Xpanse Portal
 *
 * The version of the OpenAPI document: @project.version@
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PresignedReportingDashboardDTO
 */
export interface PresignedReportingDashboardDTO {
    /**
     * 
     * @type {string}
     * @memberof PresignedReportingDashboardDTO
     */
    alias: string;
    /**
     * 
     * @type {string}
     * @memberof PresignedReportingDashboardDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof PresignedReportingDashboardDTO
     */
    slug: string;
    /**
     * 
     * @type {string}
     * @memberof PresignedReportingDashboardDTO
     */
    preSignedURL: string;
}

/**
 * Check if a given object implements the PresignedReportingDashboardDTO interface.
 */
export function instanceOfPresignedReportingDashboardDTO(value: object): value is PresignedReportingDashboardDTO {
    if (!('alias' in value) || value['alias'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('slug' in value) || value['slug'] === undefined) return false;
    if (!('preSignedURL' in value) || value['preSignedURL'] === undefined) return false;
    return true;
}

export function PresignedReportingDashboardDTOFromJSON(json: any): PresignedReportingDashboardDTO {
    return PresignedReportingDashboardDTOFromJSONTyped(json, false);
}

export function PresignedReportingDashboardDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresignedReportingDashboardDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'alias': json['alias'],
        'name': json['name'],
        'slug': json['slug'],
        'preSignedURL': json['preSignedURL'],
    };
}

export function PresignedReportingDashboardDTOToJSON(json: any): PresignedReportingDashboardDTO {
    return PresignedReportingDashboardDTOToJSONTyped(json, false);
}

export function PresignedReportingDashboardDTOToJSONTyped(value?: PresignedReportingDashboardDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'alias': value['alias'],
        'name': value['name'],
        'slug': value['slug'],
        'preSignedURL': value['preSignedURL'],
    };
}

